import { Button, Col, Input, Select, Row } from "antd";
import { useNavigate } from "react-router-dom";
import useGet from "../../../global/hooks/useGet";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { HiArrowPath } from "react-icons/hi2";
import CustomSearchBox from "../../../global/components/CustomSearchBox";
import { useEffect, useMemo, useState } from "react";

export const LicenseFilter = ({
  filter,
  handleFilterChange,
  handleFilter,
  handleReset,
  setShowModal,
  selectedRowKeys,
  setFilter,
  onSearch,
  onReset,
  searchValueExt,
  setSearchValueExt,
  optionData,
}) => {
  const navigate = useNavigate();

  const [modifiedOptions, setModifiedOptions] = useState({
    products: [],
    models: [],
    oems: [],
    sitetype: [],
  });
  // const modifiedSiteTypes = getModifiedResponse(optionData, "sitetype");

  const originalOptions = useMemo(
    () => ({
      products: getModifiedResponse(optionData, "products") || [],
      models: getModifiedResponse(optionData, "models") || [],
      sitetype: getModifiedResponse(optionData, "sitetype") || [],
      oems: getModifiedResponse(optionData, "oems") || [],
    }),
    [optionData],
  );

  useEffect(() => {
    setModifiedOptions(originalOptions);
  }, [originalOptions]);

  return (
    <div className="mb-4">
      <div className="mt-2">
        <Row gutter={[16, 16]}>
          {/* <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Input
              className="input_text_3 mr10 !h-full"
              name="LicenseNo"
              placeholder="No"
              value={filter.LicenseNo}
              onChange={handleFilterChange}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Input
              className="input_text_3 mr10 !h-full"
              name="LicenseName"
              placeholder="Name"
              value={filter.LicenseName}
              onChange={handleFilterChange}
            />
          </Col> */}
          {/* <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Select
              showSearch
              placeholder="License Type"
              optionFilterProp="LicenseType"
              value={filter.LicenseType || undefined}
              onChange={(value) => setFilter({ ...filter, LicenseType: value })}
              onSearch={onSearch}
              options={modifiedLicenseTypes}
              style={{ width: "100%" }}
            />
          </Col> */}
          <Col xs={24} sm={24} md={12} lg={8} xl={6} className="!h-[32px]">
            <Input
              className="input_text_3 mr10 h-full"
              name="LicenseName"
              placeholder="Name"
              value={filter.LicenseName}
              onChange={handleFilterChange}
            />
            {/* <CustomSearchBox
              options={[
                // { label: "No", value: "LicenseNo", type: "number" },
                { label: "Name", value: "LicenseName", type: "text" },
              ]}
              onSearch={onSearch}
              onReset={onReset}
              searchValueExt={searchValueExt}
              setSearchValueExt={setSearchValueExt}
              wrapperClassName={"sm:!max-w-full lg:!max-w-full"}
            /> */}
          </Col>
          {/* <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Select
              showSearch
              allowClear
              placeholder="Product"
              optionFilterProp="Product"
              value={filter.Product && Number(filter.Product)}
              onChange={(value) => {
                setFilter({ ...filter, Product: value });
                // onSearch({ ...filter, ProductNo: value });
              }}
              onSearch={(value) => {
                // onFilterSearch("Product", value);
              }}
              options={modifiedOptions?.products}
              style={{ width: "100%" }}
            />
          </Col> */}
          {/* <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Select
              showSearch
              placeholder="Old Model"
              optionFilterProp="OldModel"
              value={filter.OldModel || undefined}
              onChange={(value) => setFilter({ ...filter, OldModel: value })}
              onSearch={onSearch}
              options={modifiedOldModels}
              style={{ width: "100%" }}
            />
          </Col> */}
          <Col xs={24} sm={24} md={12} lg={6} xl={6}>
            <Select
              showSearch
              placeholder="Site Type"
              optionFilterProp="label"
              value={
                filter.SiteType || filter.SiteType === 0
                  ? Number(filter.SiteType)
                  : undefined
              }
              onChange={(value) => setFilter({ ...filter, SiteType: value })}
              onSearch={onSearch}
              options={modifiedOptions?.sitetype?.filter(
                (item) => item.value < 3,
              )}
              style={{ width: "100%" }}
              allowClear
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Select
              showSearch
              allowClear
              placeholder="Model"
              optionFilterProp="label"
              value={
                filter.Model?.toString() ? Number(filter.Model) : undefined
              }
              onChange={(value) => {
                setFilter({ ...filter, Model: value });
                // onSearch({ ...filter, ModelNo: value });
              }}
              onSearch={(value) => {
                // onFilterSearch("Model", value);
              }}
              options={modifiedOptions?.models}
              style={{ width: "100%" }}
            />
          </Col>
          {/* <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Input
              className="input_text_3 mr10 !h-full"
              name="OldType"
              placeholder="Old Type"
              value={filter.OldType}
              onChange={handleFilterChange}
            />
          </Col> */}
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Input
              className="input_text_3 mr10 !h-full"
              name="Type"
              placeholder="Door"
              value={filter.Type}
              onChange={(e) => {
                const { value } = e.target;
                // Allow only positive integers or empty string
                if (/^[1-9]\d*$/.test(value) || value === "") {
                  handleFilterChange(e);
                }
              }}
            />
          </Col>
          {/* <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Select
              showSearch
              allowClear
              placeholder="OEM"
              optionFilterProp="label"
              value={filter.OemNo || undefined}
              onChange={(value) => {
                // setFilter({ ...filter, OemNo: value });
                onSearch({ ...filter, OemNo: value });
              }}
              onSearch={(value) => {
                onFilterSearch("OEM", value);
              }}
              options={modifiedOptions?.oems}
              style={{ width: "100%" }}
            />
          </Col> */}
        </Row>
      </div>
      <div className="w-full overflow-x-auto ">
        <div className="flex justify-between mt-4">
          <div className="flex items-center">
            <Button
              type="primary"
              className="mr-2 w-[104px] h-[30px] font-medium flex"
              onClick={handleFilter}
            >
              <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
              <span>Apply</span>
            </Button>
            <Button
              className="reset-button w-[104px] h-[30px] font-medium"
              onClick={handleReset}
            >
              <HiArrowPath className="!text-[14px] font-medium" />
              Reset
            </Button>
            <Button
              type="primary"
              className="mr-2 -ml-2 w-[104px] h-[30px] font-medium"
              onClick={() => navigate("/license/add")}
            >
              <PlusOutlined className="" />
              Add
            </Button>
            <Button
              type="primary"
              className="mr-2 w-[104px] h-[30px] font-medium"
              disabled={selectedRowKeys?.length === 0 ? true : false}
              onClick={() => {
                setShowModal(true);
              }}
            >
              <DeleteOutlined className="" />
              Delete
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
